import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadBannerTextHIWWhyChooseWkdaFaq,
  CarleadLicensePlateDefaultStep1,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadLicensePlateDefaultStep1}
      content={CarleadBannerTextHIWWhyChooseWkdaFaq}
      showCounterHeadline={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
